import ApiModelWithAuth from "../../../models/ApiModelWithAuth";
import Formatter from "../../../models/Formatter";

// Замеры производительности (PCMark) — сквозной по ферме read-only список + карточка.
// Создание/правка/удаление недоступны (строки пишет сам скрипт). См. спецификацию §4.
export class BenchmarkFormatter extends Formatter {
    // value/device_name/node_name/device_type_code/data/device отдаём как есть;
    // id/created_at/updated_at нормализует базовый Formatter.Item.
}

export default class ApiBenchmark extends ApiModelWithAuth {
    pathDef = 'authorized/admin/benchmarks';
    formatterItem = BenchmarkFormatter.Item;

    // Карточка (show) приходит ПЛОСКИМ объектом, БЕЗ Laravel-обёртки data (см. спецификацию:
    // одиночные ресурсы — объект верхнего уровня). При этом у самой записи есть СВОЁ поле data
    // (подтесты). Базовый parseResponse по 'data' in response развернул бы его как обёртку и
    // вернул подтесты вместо записи — поэтому для show разворачиваем сами, без unwrap.
    parseResponse(response) {
        if (this.__type === 'show') {
            if (response === null || response === undefined) return null;
            return this.formatterItem ? this.formatterItem(response) : response;
        }
        return super.parseResponse(response);
    }
}
